import ImageModal from './ImageModal';

export default ImageModal;
